// "From A to B" (owner 2026-10-31): a tour stop's move. A is the picture the camera arrives at (the stop's own), B is
// `moveOptions.to`, a view saved in the builder ("End picture: use what's on screen"). Over the whole stay the camera
// goes from A to B, at rest when it begins and when it ends: where it stands, what it looks at, the lens and the
// look-up (`lookUp`, headlook.js). Without a B the camera holds, as Hold does.
// moveOptions:
//   to      { position, target, fov?, lookUp? }: the end picture, local metres
//   travel  seconds of the flight to A (default 3.2; 0 = a cut)
import { easeInOut } from './rig.js';

const num3 = (a) => Array.isArray(a) && a.length === 3 && a.every(Number.isFinite);
const mix = (a, b, k) => a + (b - a) * k;

export default function aToB(o, rig) {
  const to = num3(o.to?.position) && num3(o.to?.target) ? o.to : null;
  let from = null;
  return {
    travel: Number.isFinite(o.travel) ? Math.max(0, o.travel) : 3.2,
    hold: false,
    step(dt, t, len) {
      if (!to) return;
      from ||= rig.view();
      const k = easeInOut(len > 0 ? Math.min(1, t / len) : 1), up = from.lookUp ?? 0;
      rig.set({
        position: from.position.map((v, i) => mix(v, to.position[i], k)), target: from.target.map((v, i) => mix(v, to.target[i], k)),
        ...(to.fov > 0 && from.fov > 0 && { fov: mix(from.fov, to.fov, k) }), lookUp: mix(up, Number.isFinite(to.lookUp) ? Math.max(0, to.lookUp) : 0, k),
      });
    },
  };
}
